export default __webpack_public_path__ + "static/glorium_logo-acc2823df73605e929c20c10422527fb.svg";